// extracted by mini-css-extract-plugin
module.exports = {"container":"PageWarning_container__VsalA","warning":"PageWarning_warning__xCT6a","whiteBg":"PageWarning_whiteBg__6lhYk"};